import React from 'react';
import { Select } from '@mui/material';
import withAddOptionSelect from './withAddOptionSelect';

interface AddOptionSelectProps {
  options: Array<{ id: string; name: string; [key: string]: any }>;
  value: string;
  onChange: (event: any, child?: React.ReactNode) => void;
  placeholder?: string;
  label?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  disabled?: boolean;
  required?: boolean;
  onAddNew?: (newItem: { name: string }) => Promise<{ id: string; name: string }>;
  canAddNew?: boolean;
  addDialogTitle?: string;
  addDialogLabel?: string;
  addDialogPlaceholder?: string;
  sx?: any;
}

const EnhancedSelect = withAddOptionSelect(Select);

const AddOptionSelect: React.FC<AddOptionSelectProps> = (props) => {
  return <EnhancedSelect {...props} />;
};

export default AddOptionSelect;
